import { Button, TextField } from "@mui/material";
import React, { useState } from "react";
import styles from "./judge.module.css";

import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import { useEffect } from "react";
import { token_api } from "../../Utils/Network";

const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;
const mic = new SpeechRecognition();

mic.continuous = true;
mic.interimResults = true;
mic.lang = "en-US";

const CustomJudgement = ({ userId, id, ...props }) => {
  const [card, setCard] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [note, setNote] = useState(null);
  const [edit, setEdit] = useState(false);
  useEffect(() => {
    handleListen();
  }, [isListening]);

  const handleListen = () => {
    if (isListening) {
      mic.start();
      mic.onend = () => {
        console.log("continue..");
        mic.start();
      };
    } else {
      mic.stop();
      mic.onend = () => {
        console.log("Stopped Mic on Click");
      };
    }
    mic.onstart = () => {
      console.log("Mics on");
    };

    mic.onresult = (event) => {
      const transcript = Array.from(event.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join("");
      console.log(transcript);
      setNote(transcript);
      setJudgement(transcript);
      mic.onerror = (event) => {
        console.log(event.error);
      };
    };
  };

  const [judgement, setJudgement] = useState("");

  // const { transcript, resetTranscript } = useSpeechRecognition();
  // console.log("transcript", transcript);
  // useEffect(() => {
  //   setJudgement(transcript);
  // }, [transcript]);

  // if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
  //   return null;
  // }

  const handleStudentProfileSubmit = (e) => {
    e.preventDefault();
    setCard(true);
    // hit THE API
    let data = {};
    data = {
      user_id: userId,
      extra_information: {
        session: id,
        judgment: judgement,
      },
    };

    token_api
      .post(
        `/counseling/add/student/update_student_profile/?user=${userId}`,
        data
      )
      .then((response) => {
        console.log("CheckingResponseafterpost", response.data.data);
        // setStudentDream(response?.data?.data?.dream)
      })
      .catch((err) => {
        console.log(err);
      });
    setEdit(true);

    console.log("judgement", data);
  };

  const toggleEdit = () => {
    setCard(false);
    setEdit(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    // DISPATCH

    setJudgement(value);
  };

  // console.log("studentProfilew", judgement);
  return (
    <>
      <div className={styles.cardContainer}>
        <div className={styles.editStyle}>
          <span className={styles.font20}>Judgement</span>

          {isListening == false ? (
            <MicOffIcon
              sx={{ color: "#f71302" }}
              onClick={() => setIsListening((prevState) => !prevState)}
            />
          ) : (
            <MicIcon
              sx={{ color: "#02f733" }}
              onClick={() => setIsListening((prevState) => !prevState)}
            />
          )}

          {/* <Button
            size="small"
            onClick={() => setIsListening((prevState) => !prevState)}
          >
            {" "}
            Start/Stop Mic
          </Button> */}
          {/* <Button onClick={SpeechRecognition.startListening} > Speech Start</Button>
         <Button onClick={SpeechRecognition.stopListening}>Speech Stop</Button> */}
          <div style={{ display: "flex" }}>
            {/* <span onClick={SpeechRecognition.startListening}>
              <MicIcon />
            </span>

            <span onClick={SpeechRecognition.stopListening}>
              <MicOffIcon />
            </span> */}

            {edit && (
              <span style={{ cursor: "Pointer" }} onClick={toggleEdit}>
                Edit
              </span>
            )}
          </div>
        </div>
        {card == false ? (
          <>
            <div>
              <form onSubmit={handleStudentProfileSubmit}>
                <TextField
                  fullWidth
                  //   id="outlined-required"
                  //   label="Required"

                  onChange={handleChange}
                  name="judgment"
                  value={judgement}
                  multiline
                  required
                  rows={4}
                />
                <Button
                  style={{ position: "relative", left: "82%" , marginTop:'10px'}}
                  size="small"
                  variant="contained"
                  type="submit"
                >
                  Save
                </Button>
              </form>
            </div>
          </>
        ) : (
          <>
            <div className={styles.showCard}>{judgement && judgement}</div>
          </>
        )}

        {/* show card */}
      </div>
    </>
  );
};

export default CustomJudgement;
